import React from 'react';
import PropTypes from 'prop-types';

const CheckCircle = ({ className, color, onClick, tabIndex }) => (
  <svg
    className={className}
    tabIndex={tabIndex}
    onClick={onClick}
    viewBox="0 0 24 24"
  >
    <path
      d="M10.44 16.733c.454.448 1.203.377 1.567-.148l1.15-1.666 3.69-5.335c.322-.467.205-1.108-.262-1.43-.467-.324-1.108-.207-1.43.26l-4.145 6.018-2.288-2.278c-.405-.398-1.056-.393-1.455.012-.398.404-.393 1.056.01 1.454l3.162 3.113z"
      fill={color}
      fillRule="evenodd"
    />
    <path
      d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

CheckCircle.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
  tabIndex: PropTypes.number,
};

CheckCircle.defaultProps = {
  color: '#BABCBF',
};

export default CheckCircle;
